import { authenticatedJsonRequest } from '../../auth/authenticatedFetch';

async function request(path, options = {}) {
    return authenticatedJsonRequest(path, options);
}

export async function generateProjectPdf(projectId) {
    return request(`/api/project-pdf/${projectId}/generate`, { method: 'POST' });
}

export async function getLatestProjectPdf(projectId) {
    return request(`/api/project-pdf/${projectId}/latest`, { method: 'GET' });
}

export async function createProjectPdfShareLink(projectId) {
    return request(`/api/project-pdf/${projectId}/share-link`, { method: 'POST' });
}
